export const setHasSelectedPlace = () => state => {
  return {
    ...state,
    unvisitedPlaces: {
      ...state.unvisitedPlaces,
      hasSelectedAPlace: !state.unvisitedPlaces.hasSelectedAPlace,
    },
  };
};
